/**
 * Get visitor detail page path with double-encoded visitorId param
 * @param  {string} visitorId
 */
export function getVisitorDetailUrl (visitorId) {
    return `/visitor/${encodeURIComponent(encodeURIComponent(visitorId))}`;
}
